import React, { useState } from "react";
import { TileContainer } from "@vds3/tiles";
import {Title,Body,Micro} from "@vds3/typography"
import { MarginSpacerL, MarginSpacerM, MarginSpacerS } from "../../Pages/Checkout/styleTag";
import { Button,TextLinkCaret } from "@vds3/buttons";
import Tag from '@vds3/icons/tag';
import Checkmark from '@vds3/icons/checkmark';
import { FCC } from "../../Pages/CustomizeOrder/InternetServiceComponent/InternetSpeed/FCC";
import { useTranslation } from "react-i18next";
import {UnorderedList,ListItem} from '@vds3/lists'
import styled from "styled-components";
import { Tooltip } from '@vds3/tooltips';
import AlternateCheckmark from '@vds3/icons/alternate-checkmark';
import { TextLink } from "@vds3/buttons";
import { Modal,ModalTitle } from "@vds3/modals";
import { InputStepper } from '@vds3/input-stepper'
import {Badge} from '@vds3/badges';
import * as SiteAnalyticsOmni from '../../sitecatalyst/omniDl';
	
const CommonPlanTile = ({ProductName="",id="",PlanIncluded=[],BestForPlan=[],Price='',APPFBPriceText=[],selectedPlan='',fccLabel="",ProductId="",handleSelectedPlan=()=>{},fromEquipment=false,selectedInternetPlan={},...props})=>{
  const {t,ready} = useTranslation(['customize-order','fios'])
  const showPlanEyerow = CheckAEMBoolValue(t("showPlanEyerow",{ns:'customize-order'}))
  const isRingCameraEnabled = CheckAEMBoolValue(t("RingCameraOffer",{ns:'customize-order'}))
  const ringOfferHeader = t("ringmodalHeader",{ns:'customize-order'})
  const ringOfferBody = t("ringmodalBody",{ns:'customize-order',returnObjects:true})
  const ringOfferFooter = t("ringmodalFooter",{ns:'customize-order'})
  const prepaidOfferHeader = t("modalHeader",{ns:'customize-order'})
  const prepaidOfferBody = t("modalBody",{ns:'customize-order',returnObjects:true})
  const prepaidOfferFooter = t("modalFooter",{ns:'customize-order'})
  const RingCameracontent = t("learnmoreringmodal",{ns:'customize-order',returnObjects:true})
  const learnMoreContent = t("learnmorecommmodal",{ns:'customize-order',returnObjects:true})
  // const finalPrdName = String(ProductName).split(" ")
        // NYDMA offer labels
  const show300offerLable = t("show300offerLable",{ns:'customize-order'})
  const show500offerLable = t("show500offerLable",{ns:'customize-order'})
  const show1GigofferLable = t("show1GigofferLable",{ns:'customize-order'})
  const show2GigofferLable = t("show2GigofferLable",{ns:'customize-order'})
  const show300bundleofferLable = t("show300bundleofferLable",{ns:'customize-order'})
  const show500bundleofferLable = t("show500bundleofferLable",{ns:'customize-order'})
  const show1GigbundleofferLable = t("show1GigbundleofferLable",{ns:'customize-order'})
  const show2GigbundleofferLable = t("show2GigbundleofferLable",{ns:'customize-order'})
  const showofferLable = CheckAEMBoolValue(t("showofferLable",{ns:'customize-order'}))
  const showofferlimittime = t("showofferlimittime",{ns:'customize-order'}) !== "showofferlimittime" ? t("showofferlimittime",{ns:'customize-order'}): ""
  const showAutoPayTax = CheckAEMBoolValue(t("fios.showAutoPayTax",{ns:'fios'}))
  const showofferlimittime300 = CheckAEMBoolValue(t("showofferlimittime300",{ns:'customize-order'}))
  const showofferlimittime500 = CheckAEMBoolValue(t("showofferlimittime500",{ns:'customize-order'}))
  const showofferlimittime1G = CheckAEMBoolValue(t("showofferlimittime1G",{ns:'customize-order'}))
  const showofferlimittime2G = CheckAEMBoolValue(t("showofferlimittime2G",{ns:'customize-order'}))
  const showofferlimittime300bundle = CheckAEMBoolValue(t("showofferlimittime300bundle",{ns:'customize-order'}))
  const showofferlimittime500bundle = CheckAEMBoolValue(t("showofferlimittime500bundle",{ns:'customize-order'}))
  const showofferlimittime1Gbundle = CheckAEMBoolValue(t("showofferlimittime1Gbundle",{ns:'customize-order'}))
  const showofferlimittime2Gbundle = CheckAEMBoolValue(t("showofferlimittime2Gbundle",{ns:'customize-order'}))
  const billingToolTip = t("billingToolTip",{ns:'customize-order'}) 


  const finalPrdName = String(ProductName).split('&')
  let holidayText = ProductName?.includes('500') && ProductName?.includes('940M') && ProductName?.includes('upgraded') && ProductName?.split('upgraded');
  let bundleHolidayText = ProductName?.includes('500') && ProductName?.includes('940') && ProductName?.includes('&') && ProductName?.split('&'); 
  let offerText = ''
  let planIncludedNew = []
  if(PlanIncluded && PlanIncluded.length){
    offerText = PlanIncluded.find(data=>(String(data['Name']).toLowerCase().includes('card') || String(data['Name']).toLowerCase().includes('6 months on us') || String(data['Name']).toLowerCase().includes('ring camera')) ? true : false)
    planIncludedNew = (offerText&&offerText['Name']) ? PlanIncluded.filter(data=>data['Name'] !== offerText['Name']) : PlanIncluded
  }
  const planSel = ProductId === selectedPlan ? true : false
    const routerPrdName = fromEquipment ? String(ProductName).split('|') : undefined
    const routerType = (fromEquipment && routerPrdName && routerPrdName.length && routerPrdName.length > 1) ? String(routerPrdName[1]).toLowerCase().includes('rent') ? 'rent' : String(routerPrdName[1]).toLowerCase().includes('buy') ? 'buy' : 'own' : ''
    let offerlabel = false
    let IsNYDMA = props?.addressQualificationDetails?.IsNYDMA ? props?.addressQualificationDetails?.IsNYDMA : props?.IsNYDMA ? props?.IsNYDMA: props?.getPostLqData?.IsNYDMA ? props?.getPostLqData?.IsNYDMA : "N";
    if(props?.servicesInCart==="DATA"){
    if(finalPrdName[0].includes("300")&&showofferlimittime300){
      offerlabel = true
  }else if(finalPrdName[0].includes("500") && showofferlimittime500){
      offerlabel = true
  }else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&showofferlimittime1G){
      offerlabel = true
  }else if(finalPrdName[0].toLowerCase().includes("2 gig")&&showofferlimittime2G){
      offerlabel = true
  }
  }else if(props?.servicesInCart==="DATA+BDV" || props?.servicesInCart==="BDV+DATA"){
    if(finalPrdName[0].includes("300")&&showofferlimittime300bundle){
      offerlabel = true
  }else if(finalPrdName[0].includes("500") && showofferlimittime500bundle){
      offerlabel = true
  }else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&showofferlimittime1Gbundle){
      offerlabel = true
  }else if(finalPrdName[0].toLowerCase().includes("2 gig")&& showofferlimittime2Gbundle){
      offerlabel = true
  }
}
  let SwatToolTip = "Businesses who purchase a 500 Mbps (mid-tier) plan will receive a price value that is equal to our low-tier plan. This offer is for qualifying demographics only. For a limited time."

    return(
      <div style={{display:"flex",flexDirection:"column",gap:"0.6rem"}}>
         {!fromEquipment && IsNYDMA === "Y" && <Micro id={showofferLable && offerlabel && IsNYDMA === "Y"?"swat-offer-text-red-bg":"swat-offer-text-white-bg"} bold color={'#FFFFFF'}>{showofferLable && offerlabel && IsNYDMA === "Y"?<>{showofferlimittime}</>:""}</Micro>}
        <TileContainer
        padding='0'
        width={'290px'}
        backgroundColor="white"
        height={props.servicesInCart==="DATA"?"auto":"100%"}
        // showBorder={planSel}
      >
        <div className={"wdth-tle-ctnr "+ (planSel && !props?.showStepper? 'show-brdr-tle' : planSel && props?.showStepper && props?.routerNos>0? 'show-brdr-tle':'')}>
      <HeaderSectionPlan holidayText={holidayText} bundleHolidayText={bundleHolidayText} routerPrdName={routerPrdName} offerText={offerText} finalPrdName={finalPrdName} showPlanEyerow={showPlanEyerow} ProductName={ProductName} t={t} fromEquipment={fromEquipment} planSel={planSel} isIncludedOfferEligible={props.isIncludedOfferEligible??false}  servicesInCart={props?.servicesInCart} isRingCameraEnabled={isRingCameraEnabled} ringOfferHeader={ringOfferHeader} ringOfferBody={ringOfferBody} ringOfferFooter={ringOfferFooter} prepaidOfferHeader={prepaidOfferHeader} prepaidOfferBody={prepaidOfferBody} prepaidOfferFooter={prepaidOfferFooter}  learnMoreContent={learnMoreContent} RingCameracontent={RingCameracontent} showStepper={props?.showStepper} routerNos={props?.routerNos} {...props}/>
      <br/>
      <BodySectionPlan BestForPlan={BestForPlan} Price={Price} APPFBPriceText={APPFBPriceText} isIncludedOfferEligible={props.isIncludedOfferEligible??false} handleSelectedPlan = {()=>{
        const ownRouter = (routerType==='own') ? true : false
        if(ownRouter) handleSelectedPlan(ProductId,routerPrdName,ownRouter)
        else{
          handleSelectedPlan(ProductId,ProductName)
          props.setPlanAccordian(!props?.opened)
          SiteAnalyticsOmni.addToCart({ProductId, fromEquipment, routerType, planSel, props}, "plan tile");
        }
      }}
      planSelected={planSel} planIncluded={planIncludedNew} fromEquipment={fromEquipment} routerType={routerType} {...props} ProductName={ProductName} selectedInternetPlan={selectedInternetPlan} IsNYDMA={IsNYDMA} finalPrdName={finalPrdName}  showAutoPayTax={showAutoPayTax}
      billingToolTip={billingToolTip}/>
      {fromEquipment ? <></> : 
      <FCCLabel fccLabel={fccLabel} {...props} planSel={planSel}/>}
      </div>
      </TileContainer>
      </div>
    )
}

const HeaderSectionPlan = ({holidayText,bundleHolidayText,finalPrdName=[],offerText='',showPlanEyerow=false,ProductName,t,routerPrdName=[],fromEquipment,planSel=false,isIncludedOfferEligible,servicesInCart,isRingCameraEnabled=false,ringOfferHeader="",ringOfferBody=[],ringOfferFooter='',prepaidOfferHeader="",prepaidOfferBody=[],prepaidOfferFooter='',learnMoreContent="",RingCameracontent="",showStepper=false,routerNos=0,...props})=>{
  const [viewFeaturesModal,setViewFeaturesModal]=useState(false)
  const [specialOfferModal, setSpecialOfferModal] = useState(false);
  const show300PlanEyerowLabel = t("show300PlanEyerowLabel",{ns:'customize-order'})
  const enableBannerBackgroundColor = CheckAEMBoolValue(t("enableBannerBackgroundColor",{ns:'customize-order'}))
  const rentRouterIncludetext = t("rentRouterIncludetext",{ns:'customize-order'})
  const rentRouterLearnmoreText = t("rentRouterLearnmoreText",{ns:'customize-order',returnObjects:true})
  const rentRouterBackroundColor = t("rentRouterBackroundColor",{ns:'customize-order'})
  const rentRoutertextColor = t("rentRoutertextColor",{ns:'customize-order'})
  const rentRouterFontSize = t("rentRouterFontSize",{ns:'customize-order'})
  const _300Speedtext = t("fios.300Speedtext",{ns:'fios'})
  const _500Speedtext = t("fios.500Speedtext",{ns:'fios'})
  const _1GSpeedtext = t("fios.1GSpeedtext",{ns:'fios'})
  const _2GSpeedtext = t("fios.2GSpeedtext",{ns:'fios'})
  const enabledspeedtext = CheckAEMBoolValue(t("fios.enabledspeedtext",{ns:'fios'}))
  const SpeedBundltext = t("fios.SpeedBundltext",{ns:'fios'})
  // NYDMA offer labels
  const show300offerLable = t("show300offerLable",{ns:'customize-order'})
  const show500offerLable = t("show500offerLable",{ns:'customize-order'})
  const show1GigofferLable = t("show1GigofferLable",{ns:'customize-order'})
  const show2GigofferLable = t("show2GigofferLable",{ns:'customize-order'})
  const show300bundleofferLable = t("show300bundleofferLable",{ns:'customize-order'})
  const show500bundleofferLable = t("show500bundleofferLable",{ns:'customize-order'})
  const show1GigbundleofferLable = t("show1GigbundleofferLable",{ns:'customize-order'})
  const show2GigbundleofferLable = t("show2GigbundleofferLable",{ns:'customize-order'})
   
  //non NYDMA offer labels
  const show300offerLableNonNy = t("show300offerLableNon-NY",{ns:'customize-order'})
  const show500offerLableNonNy = t("show500offerLableNon-NY",{ns:'customize-order'})
  const show1GigofferLableNonNy = t("show1GigofferLableNon-NY",{ns:'customize-order'})
  const show2GigofferLableNonNy = t("show2GigofferLableNon-NY",{ns:'customize-order'})
  const show300bundleofferLableNonNy = t("show300bundleofferLableNon-NY",{ns:'customize-order'})
  const show500bundleofferLableNonNy = t("show500bundleofferLableNon-NY",{ns:'customize-order'})
  const show1GigbundleofferLableNonNy = t("show1GigbundleofferLableNon-NY",{ns:'customize-order'})
  const show2GigbundleofferLableNonNy = t("show2GigbundleofferLableNon-NY",{ns:'customize-order'})
  const showOfferLableBody = CheckAEMBoolValue(t("showOfferLableBody",{ns:'customize-order'}))
  let eyeBrowText = ''
  let offerlabel = false
  let offerlabelNonNy = false
  let IsNYDMA = props?.addressQualificationDetails?.IsNYDMA ? props?.addressQualificationDetails?.IsNYDMA : props?.IsNYDMA ? props?.IsNYDMA: props?.getPostLqData?.IsNYDMA ? props?.getPostLqData?.IsNYDMA : "N";
  if(servicesInCart==="DATA"){
    if(finalPrdName[0].includes("300")&&show300offerLable!==""){
      offerlabel = true
  }else if(finalPrdName[0].includes("500")&&show500offerLable!==""){
      offerlabel = true
  }else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&show1GigofferLable!==""){
      offerlabel = true
  }else if(finalPrdName[0].toLowerCase().includes("2 gig")&&show2GigofferLable!==""){
      offerlabel = true
  }
  if(finalPrdName[0].includes("300")&&show300offerLableNonNy!==""){
    offerlabelNonNy = true
}else if(finalPrdName[0].includes("500")&&show500offerLableNonNy!==""){
    offerlabelNonNy = true
}else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&show1GigofferLableNonNy!==""){
    offerlabelNonNy = true
}else if(finalPrdName[0].toLowerCase().includes("2 gig")&&show2GigofferLableNonNy!==""){
    offerlabelNonNy = true
}
  }else if(servicesInCart==="DATA+BDV"||servicesInCart==="BDV+DATA"){
    if(finalPrdName[0].includes("300")&&show300bundleofferLable!==""){
      offerlabel = true
  }else if(finalPrdName[0].includes("500")&&show500bundleofferLable!==""){
      offerlabel = true
  }else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&show1GigbundleofferLable!==""){
      offerlabel = true
  }else if(finalPrdName[0].toLowerCase().includes("2 gig")&&show2GigbundleofferLable!==""){
      offerlabel = true
  }
  if(finalPrdName[0].includes("300")&&show300bundleofferLableNonNy!==""){
    offerlabelNonNy = true
}else if(finalPrdName[0].includes("500")&&show500bundleofferLableNonNy!==""){
    offerlabelNonNy = true
}else if((finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&show1GigbundleofferLableNonNy!==""){
    offerlabelNonNy = true
}else if(finalPrdName[0].toLowerCase().includes("2 gig")&&show2GigbundleofferLableNonNy!==""){
    offerlabelNonNy = true
}
}
  if(showPlanEyerow){
    if((ProductName?.includes('Fios Gigabit Connection') ||ProductName?.includes('Gigabit Connection') || ProductName?.includes('940/880 Mbps') || String(ProductName).toLowerCase().includes('1 gig'))) eyeBrowText = t("show1GigPlanEyerowLable")
  }
const useMyOwn = (routerPrdName && routerPrdName.length && routerPrdName.length > 1 && String(routerPrdName[0]).toLowerCase().includes('bring') && String(routerPrdName[0]).toLowerCase().includes('own')) ? true : false
const  modalChange = (viewFeaturesModal) => {
  setViewFeaturesModal(viewFeaturesModal)
};
let includesWebex = false
  if(!fromEquipment){
  if(finalPrdName.length > 1 && String(finalPrdName[1]).toLowerCase().includes('webex')){
    includesWebex = String(finalPrdName[1]).replace('webex',"").replace('Webex',"").replace('WEBEX',"")
  }
}
 const renderModal = () => {

  return (<Modal
      ariaLabel=""
      opened={viewFeaturesModal}
      onOpenedChange={modalChange}
      disableOutsideClick={true} disableFocusLock= {true} 
  >
      {rentRouterLearnmoreText&&(
        <div dangerouslySetInnerHTML={{ __html: rentRouterLearnmoreText }}></div> 
      )}
  </Modal>);
 };  
 const specialOfferModalChange = (specialOfferModal) => {
  setSpecialOfferModal(specialOfferModal);
}; 
const renderSpecialOfferModal = () => {
  return (
    <Modal
      ariaLabel=""
      opened={specialOfferModal}
      onOpenedChange={specialOfferModalChange}
      disableOutsideClick={true}
    >
      <div>
        {isRingCameraEnabled?
        RingCameracontent && (
        <div dangerouslySetInnerHTML={{ __html: RingCameracontent }}></div>
      ):
        learnMoreContent && ( 
        <div dangerouslySetInnerHTML={{ __html: learnMoreContent }}></div> 
        )
      }
        <div style={{ marginTop: "20px" }}>
          <Button onClick={() => specialOfferModalChange(false)} className="closeBtn-popup">
            Close
          </Button>
        </div>
      </div>
    </Modal>)
}
return(
    <div style={{width:'100%',padding:'1rem',height:fromEquipment ? '96px' : servicesInCart==="DATA"?"160px":'220px',position:enableBannerBackgroundColor?"relative":"static"}}>
      {renderSpecialOfferModal()}
      {viewFeaturesModal && renderModal()}
       {planSel  && !showStepper? 
      <div className={fromEquipment?"router-pos-abs-ic":"pos-abs-ic"}>
      <AlternateCheckmark color={"#008331"} size="XLarge"/>
      </div>:<></>}
      {planSel  && showStepper && routerNos>0? 
      <div className={fromEquipment?"router-pos-abs-ic":"pos-abs-ic"}>
      <AlternateCheckmark color={"#008331"} size="XLarge"/>
      </div>:<></>}
      {fromEquipment ? <></> : 
      <div style={{height:'30px'}}>
        <Body id="plan-card-txt" size="large"  bold="true" color={'#EE0000'}>{eyeBrowText}</Body>
      </div>}
    <MarginSpacerM/>
    {(routerPrdName && routerPrdName.length && routerPrdName.length > 1) ? <>
        <span style={{display:'inline'}}>
          <div style={{display:'flex',justifyContent:'space-between'}}>
        <div>
        <Title size="small" bold>{String(routerPrdName[0])}</Title>
        {useMyOwn ? <></> : <Title size="small" bold>{String(routerPrdName[1])}</Title>}
        </div>
        {useMyOwn ? <></> : 
        <img src={require("../../assets/images/verizon-router-front.png")} width={'33px'} height={'50px'}/>}
        </div>
        <div>
        {/* <MarginSpacerM/> */}
        <span className="router-eyerow-text" style={{display:(String(routerPrdName[1])==="Rent" && isIncludedOfferEligible)?"inline-flex":"none",color:rentRoutertextColor,backgroundColor:rentRouterBackroundColor,fontSize:rentRouterFontSize}}>
          <Tag color={'#EE0000'} size="small"/>&nbsp;
          <div dangerouslySetInnerHTML={{__html:rentRouterIncludetext}} ></div><TextLink style={{ marginLeft: '14px'}} onClick={()=>setViewFeaturesModal(true)}>Learn More</TextLink></span>
        </div>
      </span>
    </> : 
     <span >
     {(holidayText&&holidayText.length > 1) ? 
     <>
     <Title size="XLarge" bold>{holidayText[0]}</Title>
     {bundleHolidayText&&bundleHolidayText.length>1 ? <Title size="XLarge" bold>{bundleHolidayText[0]}</Title> : <></>}
     </>
     :
     <>
   <Title size="XLarge" bold>{enabledspeedtext?(finalPrdName[0].includes("300")?_300Speedtext:finalPrdName[0].includes("500")?_500Speedtext:finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit")?_1GSpeedtext:finalPrdName[0].toLowerCase().includes("2 gig")?_2GSpeedtext:finalPrdName[0]):finalPrdName[0]}</Title>
   <Title size="large" bold>{enabledspeedtext&&servicesInCart!=="DATA"?SpeedBundltext:finalPrdName.length >1 ? ('&' + finalPrdName[1]) : ''}</Title>
   {(finalPrdName.length > 1 && includesWebex) ?
     <Title size="small" viewport="mobile" primitive="h1">
     Webex
   </Title> 
     :<></>}
   </>}
   </span>
    }
    <MarginSpacerM/>
    {ProductName?.includes("300 Mbps") ?(
      <span style={{display:'flex',alignItems:'center'}}>
    <Micro id="plan-offer-text" color={'#EE0000'}>{show300PlanEyerowLabel && show300PlanEyerowLabel!=="show300PlanEyerowLabel"?show300PlanEyerowLabel:""}</Micro></span>):<></>}
    {showOfferLableBody && offerlabel && IsNYDMA === "Y"?
    <span className={enableBannerBackgroundColor?"holiday-offer-container-vds3-red":"holiday-offer-container-vds3"} style={{marginTop:enableBannerBackgroundColor && servicesInCart==="DATA"?"0.7rem":"0rem"}}>
    {enableBannerBackgroundColor?<></>:<><Tag color={'#EE0000'} size="small"/>&nbsp;</>}
    <Micro id={enableBannerBackgroundColor?"plan-offer-text-red":"plan-offer-text"} bold color={enableBannerBackgroundColor?'#FFFFFF':'#EE0000'}>{finalPrdName[0].includes("300")&&servicesInCart!=="DATA"?show300bundleofferLable:finalPrdName[0].includes("300")&&servicesInCart==="DATA"?show300offerLable:finalPrdName[0].includes("500")&&servicesInCart!=="DATA"?show500bundleofferLable:finalPrdName[0].includes("500")&&servicesInCart==="DATA"?show500offerLable:
    (finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&servicesInCart!=="DATA"?show1GigbundleofferLable:(finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&servicesInCart==="DATA"?show1GigofferLable:finalPrdName[0].toLowerCase().includes("2 gig")&&servicesInCart!=="DATA"?show2GigbundleofferLable:finalPrdName[0].toLowerCase().includes("2 gig")&&servicesInCart==="DATA"?show2GigofferLable:<></> } <TextLink onClick={() => specialOfferModalChange(true)}>Learn more</TextLink></Micro>
    </span>:
    IsNYDMA === "N" && offerlabelNonNy?
    (<span className={enableBannerBackgroundColor?"holiday-offer-container-vds3-red":"holiday-offer-container-vds3"} style={{marginTop:enableBannerBackgroundColor && servicesInCart==="DATA"?"0.7rem":"0rem"}}>
    {enableBannerBackgroundColor?<></>:<><Tag color={'#EE0000'} size="small"/>&nbsp;</>}
    <Micro id={enableBannerBackgroundColor?"plan-offer-text-red":"plan-offer-text"} bold color={enableBannerBackgroundColor?'#FFFFFF':'#EE0000'}>{finalPrdName[0].includes("300")&&servicesInCart!=="DATA"?show300bundleofferLableNonNy:finalPrdName[0].includes("300")&&servicesInCart==="DATA"?show300offerLableNonNy:finalPrdName[0].includes("500")&&servicesInCart!=="DATA"?show500bundleofferLableNonNy:finalPrdName[0].includes("500")&&servicesInCart==="DATA"?show500offerLableNonNy:
    (finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&servicesInCart!=="DATA"?show1GigbundleofferLableNonNy:(finalPrdName[0].toLowerCase().includes("1 gig")||finalPrdName[0].toLowerCase().includes("fios gigabit"))&&servicesInCart==="DATA"?show1GigofferLableNonNy:finalPrdName[0].toLowerCase().includes("2 gig")&&servicesInCart!=="DATA"?show2GigbundleofferLableNonNy:finalPrdName[0].toLowerCase().includes("2 gig")&&servicesInCart==="DATA"?show2GigofferLableNonNy:<></> } <TextLink onClick={() => specialOfferModalChange(true)}>Learn more</TextLink></Micro>
    </span>)
    :<></>}
    {/* offerText ? 
    <span className={enableBannerBackgroundColor?"holiday-offer-container-vds3-red":"holiday-offer-container-vds3"} style={{marginTop:enableBannerBackgroundColor && servicesInCart==="DATA"?"0.7rem":"0rem"}}>
    {enableBannerBackgroundColor?<></>:<><Tag color={'#EE0000'} size="small"/>&nbsp;</>}
    <Micro id={enableBannerBackgroundColor?"plan-offer-text-red":"plan-offer-text"} bold color={enableBannerBackgroundColor?'#FFFFFF':'#EE0000'}>{offerText['Name']} <TextLink onClick={() => specialOfferModalChange(true)}>Learn more</TextLink></Micro>
    </span>
    : <></>} */}
  </div>
  )
}
const BodySectionPlan = ({BestForPlan=[],Price="",APPFBPriceText=[],planSelected=false,planIncluded=[],handleSelectedPlan=()=>{},fromEquipment=false,routerType='',ProductName='',isIncludedOfferEligible,selectedInternetPlan,IsNYDMA="N",finalPrdName=[],showAutoPayTax,billingToolTip,...props})=>{
  let bestForPlan = ''
  let appFPBText = ''
  if(BestForPlan&&BestForPlan.length) bestForPlan = BestForPlan[0]['Name']
  if(APPFBPriceText&&APPFBPriceText.length) appFPBText = APPFBPriceText[0]['Name'].replace(/autopay/i,"Auto Pay")
  const btnText = fromEquipment ? routerType === 'own' ? 'Bring your own' : planSelected ? "Selected" : 'Select router' : planSelected ? 'Selected plan':'Select plan'
  const offerPricing = (props?.jointOfferAvailResponse&&props?.jointOfferAvailResponse.JointofferStatus === 'Y') ? true : false
  const finalPrice = (offerPricing&&!fromEquipment) ? isGigSpeed(ProductName) ? Number(Price - (props?.jointOfferAvailResponse?.OneGigSpeedPrice ?? 0)) :  Number(Price - props?.jointOfferAvailResponse?.JointOfferPrice) : Number(Price)
  return(
    <div style={{width:'100%',padding:'1rem',backgroundColor:'black',borderBottomLeftRadius:fromEquipment ? '4px' : '',borderBottomRightRadius:fromEquipment ? '4px' : ''}}>
      {fromEquipment ? <></>:
      <>
      <MarginSpacerM/>
      <div style={{height:'100px'}}>
      <Body size="large" color="white">{bestForPlan}</Body>
      </div>
      <MarginSpacerL/>
      </>}
      <div style={{height:fromEquipment ? '60px' : '120px'}}>
      {isIncludedOfferEligible && (['1 gig','2 gig'].some((plan)=>selectedInternetPlan?.ProductName?.toLowerCase()?.includes(plan)) && routerType === 'rent')?
      <>
      <Title color="white" size="large" bold>Included</Title>
      <Micro color="#A7A7A7">Plus taxes and fees.</Micro>
      </> : 
      <>
      <span style={{display:'flex',alignItems:'flex-end'}}>
      <Title color={!finalPrdName[0].includes("300") && IsNYDMA==="Y" && !fromEquipment?"#EE0000":"white"} size="large" bold>${routerType === 'buy' ? Number(Price/12).toFixed(2) : finalPrice}</Title>
          <Micro color={!finalPrdName[0].includes("300") && IsNYDMA==="Y" && !fromEquipment?"#EE0000":"white"}>/mo </Micro>
        {finalPrice < Price &&
         <span style={{display:'flex',alignItems:'flex-end',color:'#00ac3e',marginLeft:"3rem"}}>
         <Body color="#00ac3e" size="large" bold>
          <span>was {"  "}</span><span style={{textDecoration:'line-through'}}>${Price}</span>
         </Body>
         </span>
        }
      </span>
      {fromEquipment ? <>
        <Micro color="#A7A7A7">{routerType === 'rent' ? 'Plus taxes and fees.' : routerType === 'buy' ? `Pay in full or over 12 months($${Number(Price/12).toFixed(2)}/mo).` : 'No additional cost.'}</Micro>
      </>:
      (showAutoPayTax?<>
      <MarginSpacerS/>
      <section style={{display:'flex',flexDirection:"row",gap:'0.4rem'}}>
        <Badge surface="light" numberOfLines={1} id="plantile-badge">{"Save $5"}</Badge>
        <Micro color="#A7A7A7">
          <Body color="white" size="large" bold>${Number(finalPrice)-5}/mo&nbsp;<span style={{color:"#A7A7A7",fontSize:"0.8rem",fontWeight:"400",lineHeight:"1rem"}}>{appFPBText}</span><Tooltip size="small" className="tooltip" header=" " surface="dark" id="billingToolTip">{billingToolTip}</Tooltip></Body>
          {/* <Body color="white" size="large" bold>${Number(Price || 0)}/mo&nbsp;<span style={{color:"#A7A7A7",fontSize:"0.8rem",fontWeight:"400",lineHeight:"1rem"}}>{appFPBText}</span><Tooltip size="small" className="tooltip" header=" " surface="dark" id="billingToolTip">{billingToolTip}</Tooltip></Body> */}
        </Micro>
      </section>
      <MarginSpacerM/>
      <Micro color="#A7A7A7">Plus taxes, fees, & equip charges with a 2-year term that auto renews.</Micro>
      </>:<>
      <Micro color="#A7A7A7">Plus taxes, fees, & equip charges with a 2-year term that auto renews.</Micro>
      <MarginSpacerM/>
      <Micro color="#A7A7A7">${Number(finalPrice)-5}&nbsp;{appFPBText}</Micro>
      {/* <Micro color="#A7A7A7">${Number(Price || 0)}&nbsp;{appFPBText}</Micro> */}
      </>)}
      </>
}
      </div>
      <MarginSpacerL/>
      {props?.showStepper ?
      <div className="router-wifi-stepper">
      <InputStepper
          className="router-wifi-stepper-input" defaultValue={props?.extraWiFiRouters}
          label=" " disabled={false} maxValue={5} minValue={0}
          trailingText="" surface="dark" controlWidth="100%"
          onChange={(event)=>{
              if(event<props?.routerNos){
                if (props?.extraWiFiRouters >= 1) {
                  props.setExtraWiFiRouters(props?.extraWiFiRouters-1)
                  if(props?.extraWiFiRouters-1 === 0){
                    props.setExtraNumberOfRouters(0)
                    props.setTriggerUpdateForExtraWiFiRouters(true)
                  }
                }
          }
          if(event>props?.extraWiFiRouters){
            if (props?.extraWiFiRouters < 5) {
              props.setExtraWiFiRouters(props?.extraWiFiRouters+1)
            }
          }
          }}
          /></div>
      :<Button data-track ={`{"type":"link","name":${ProductName + ':' + btnText}`} className={planSelected?"plan-selected":""} disabled={planSelected} surface="dark" use="primary" width="100%" onClick={(e)=>{e.stopPropagation();handleSelectedPlan()}}>{btnText}</Button>}
      <MarginSpacerM/>
      {(fromEquipment) ? 
      <div style={{height:'120px'}}>
      <RouterPlans features = {props.Features} routerType={routerType} enablerentrouterwifi={props?.enablerentrouterwifi} wifiRouterFeatures={props?.wifiRouterFeatures} wifibringownrouter={props?.wifibringownrouter}/> 
      </div>
      : 
      <div style={{height:'160px'}}>
      <PlansForTiles planIncluded={planIncluded}/>
      </div>}
    </div>
  )
}

const PlansForTiles = ({planIncluded=[]})=>{
  if(planIncluded && planIncluded.length){
    return planIncluded.map(plan=>{
      return(
        <div style={{display:'flex',alignItems:'flex-start',marginTop:'5px'}}>
        <Checkmark color={'white'} size="small"/>&nbsp;
        <Body size="small" color={'white'}>{plan['Name']}
          {(plan&&plan['toolTip']!==null&&plan['toolTip']) ? 
          <Tooltip size="small" className="tooltip" header=" " surface="dark">{plan['toolTip']}</Tooltip>
          :<></>}
        </Body>
        </div>
      )
    })
  }else return <></>
}
const FCCLabel = ({IsNYDMA='',fccLabel='',fccTemplate,planSel=false,...props})=>{
  const tplHTML = fccTemplate!==null&&fccTemplate ? String(JSON.parse(fccTemplate).body).replace(/&quot;/gi, "'") : ''
  return(
    <div style={{border:planSel ? '1rem solid #6F7171' : '18px solid #6F7171',borderBottomLeftRadius:planSel ? '5px' : '10px',borderBottomRightRadius:planSel ? '5px' : '10px'}}>
      <FCC 
      handleLinkClick = {(url)=>{
        // setReferralLink(url)
        // props.getQRForFiosReferral(url)
        // setShowFiosReferralModal(true)
      }}
      fiosReferral = {props.fiosReferral === 'Y'}
      IsNYDMA = {IsNYDMA === 'Y'} tplHTML = {tplHTML} fccLabel = {fccLabel}/>
    </div>
      
  )
}
const RouterPlans = ({features=[],routerType='',enablerentrouterwifi=false,wifiRouterFeatures="",wifibringownrouter=''})=>{
  const [openRouteDetails,setOpenRouteDetails] = useState(true)
  if(enablerentrouterwifi){
    if(routerType === 'own'){
      return(
        <>
     <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}} >
      <TextLinkCaretWrapper openRouteDetails={openRouteDetails} surface="dark"  iconPosition="right" onClick={e => setOpenRouteDetails(!openRouteDetails)}>Important BYOR details</TextLinkCaretWrapper>
      </div>
      {openRouteDetails ? 
      <>
      <MarginSpacerM/>
      <div dangerouslySetInnerHTML={{__html:wifibringownrouter}}></div>
      </>
      : <></>}
      </>
      )
    }
    return (
      <>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}} >
          <TextLinkCaretWrapper openRouteDetails={openRouteDetails} surface="dark"  iconPosition="right" onClick={e => setOpenRouteDetails(!openRouteDetails)}>Router features </TextLinkCaretWrapper>
        </div>
        {openRouteDetails ? 
          <div dangerouslySetInnerHTML={{__html:wifiRouterFeatures}}></div>
        :<></>}
      </>
    )
  }
  if(routerType === 'own'){
    return(
      <>
   <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}} >
    <TextLinkCaretWrapper openRouteDetails={openRouteDetails} surface="dark"  iconPosition="right" onClick={e => setOpenRouteDetails(!openRouteDetails)}>Important BYOR details</TextLinkCaretWrapper>
    </div>
    {openRouteDetails ? 
    <>
    <MarginSpacerM/>
    <Body size='small' color="white">You may use your own compatible 2 gig router, but it may not deliver the speed you expect</Body>
    </>
    : <></>}
    </>
    )
  }
  if(features && features.length){
  return(
    <>
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}} >
    <TextLinkCaretWrapper openRouteDetails={openRouteDetails} surface="dark"  iconPosition="right" onClick={e => setOpenRouteDetails(!openRouteDetails)}>Router details </TextLinkCaretWrapper>
    </div>
    {openRouteDetails ? 
    <>
    <MarginSpacerM/>
    <UnorderedList surface="dark">
      {features.map(feature=>(
        <ListItem size="bodySmall">{feature['Name']}
         {(feature&&feature['toolTip']!==null&&feature['toolTip']) ? 
          <Tooltip size="small" className="tooltip" header=" " surface="dark">{feature['toolTip']}</Tooltip>
          :<></>}
        </ListItem>
      ))}
    </UnorderedList>
    </>
    : <></>}
    </>
  )
}else return<></>
}
export const CheckAEMBoolValue = (val)=>{
  if(val && typeof val == 'boolean') return val
  return false
}
export const TextLinkCaretWrapper = styled(TextLinkCaret)`
  svg{
      transform: ${({openRouteDetails})=>openRouteDetails ? 'rotate(-90deg)!important' : 'rotate(-270deg)!important'};
  }
`
export default CommonPlanTile


const isGigSpeed = (PrdName)=>{
  if(String(PrdName).toLowerCase().includes('940') || String(PrdName).toLowerCase().includes('gig') || String(PrdName).toLowerCase().includes('20480')) return true
  return false
}